module.exports = __webpack_public_path__ + "img/2.3c12be05.png";